var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconTypePercentage = function SvgMiconTypePercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M9 14a5 5 0 1 1 0-9.999A5 5 0 0 1 9 14m0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6M26.586 4 4 26.586 5.414 28 28 5.414zM23 28a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-8a3 3 0 1 0 0 5.999A3 3 0 0 0 23 20"
  })));
};
export default SvgMiconTypePercentage;